/**
 * Producers, recruiters, and investors browse talent at /profiles.
 * Creators/talent (and guests) use /profile for the profiling form.
 */
export function isProducerLikeRole(userType) {
  const t = String(userType || '').toLowerCase();
  return t === 'producer' || t === 'recruiter' || t === 'investor';
}

export function getTalentPoolPath(userType) {
  return isProducerLikeRole(userType) ? '/profiles' : '/profile';
}

export function getTalentPoolPathFromStorage() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return '/profile';
    const u = JSON.parse(raw);
    return getTalentPoolPath(u.userType);
  } catch {
    return '/profile';
  }
}
